// extracted by mini-css-extract-plugin
module.exports = {"delta2MaxDetail":"detail_delta2MaxDetail__fX2AA"};